import React from 'react';
import startCase from 'lodash/startCase';
import { compose } from 'recompose';
import styled, { StylesProps, cx } from '../../../../../../../lib/styles';
import articleStyles from './CustomCard_styles';
import Spacer from '../../../../../../../components/presentational/Spacer';
import { CustomCard } from '../../CardBlock';
import Image from '../../../../../../../components/presentational/Image';

export interface CustomCardProps {
  card: CustomCard;
  onClick?: () => any;
  lazy: boolean;
}

const ArticleCard = ({
  onClick,
  lazy = true,
  card,
  styles,
}: CustomCardProps & StylesProps<typeof articleStyles>) => (
  <a className={`${styles.link} custom-card`} href={card.link} onClick={onClick}>
    <Spacer space={'s'}>
      <div className={styles.featureImageContainer}>
        <Image
          alt={card.title}
          className={cx(styles.image, 'CustomCard__image')}
          src={card.image}
          lazy={lazy}
          aspect={[16, 9]}
          resizeWidth={390}
          resizeFit={'min'}
        />
        {card.ribbonText && <div className={styles.tag}>{card.ribbonText}</div>}
      </div>

      <Spacer space={'xxs'} selfT={0} align={'flex-start'}>
        <span className={styles.category}>
          {startCase((card.category || '').toLowerCase())}
        </span>
        <h2 className={cx(styles.title, 'CustomCard__title')}>{card.title}</h2>

        {card.highlight && (
          <Spacer className={styles.highlight} selfV={'xxxs'} selfH={'xxs'}>
            {card.highlight}
          </Spacer>
        )}

        <Spacer row space={'xxxs'}>
          <span
            className={styles.subtitle}
            dangerouslySetInnerHTML={{ __html: card.text }}
          />
        </Spacer>
      </Spacer>
    </Spacer>
  </a>
);

export default compose(styled(articleStyles))(ArticleCard);
